import Layout from '@/layout/index.vue';
import { moqSubMenu } from './subMenus/moq-sub-menu';
import { moqsDiscountSubMenu } from './subMenus/moqs-discount-sub-menu';
import { schemesDiscountSubMenu } from './subMenus/schemes-discount-sub-menu';
import { policySubMenu } from './subMenus/policy-sub-menu';
import { policiesDiscountSubMenu } from './subMenus/policies-discount-sub-menu';
const schemeRouter = {
  path: '/schemes',
  component: Layout,
  redirect: 'noredirect',
  name: 'schemeManagement.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Product Manager'],
    title: 'schemeManagement.title',
    icon: 'discount'
  },
  children: [...policySubMenu, ...policiesDiscountSubMenu, {
    path: '/schemes/list',
    component: () => import('@/views/schemes/list.vue'),
    name: 'schemeManagement.schemes.title',
    meta: {
      title: 'schemeManagement.schemes.title',
      roles: ['Super Admin', 'Admin'],
      noCache: true,
      icon: 'discount'
    }
  }, {
    path: '/schemes/add',
    component: () => import('@/views/schemes/manage.vue'),
    name: 'schemeManagement.schemes.add',
    props: {
      isEdit: false
    },
    meta: {
      title: 'schemeManagement.schemes.add',
      roles: ['Super Admin', 'Admin'],
      noCache: true,
      hidden: true
    }
  }, {
    path: '/schemes/edit/:id(\\d+)',
    component: () => import('@/views/schemes/manage.vue'),
    name: 'schemeManagement.schemes.edit',
    props: {
      isEdit: true
    },
    meta: {
      title: 'schemeManagement.schemes.edit',
      roles: ['Super Admin', 'Admin'],
      noCache: true,
      hidden: true
    }
  }, ...schemesDiscountSubMenu, ...moqSubMenu, ...moqsDiscountSubMenu]
};
export default schemeRouter;